/* eslint-disable no-alert */
import React from 'react'
import { connect } from 'react-redux'
import moment from 'moment'
import { Segment, Dimmer, Loader } from 'semantic-ui-react'
import _ from 'lodash'
import HasuraOrderActions from '../../../reducers/hasuraOrderReducer'
import DateField from '../../../components/adminReport/fields/dateRangeSearchField'
import SaleReportSheet from '../components/SaleReportSheet'
import utils from '../../../utils/order'
// import OrderTable from './components/Table' reminder to remove this later

const headers = [
  'No.',
  'Order Id',
  'Date',
  'Time',
  "Muuver's Number",
  'Restaurant',
  'Branch',

  'COD / Pay Later',
  'Pay Later Type',

  'Amount ($)',
  'Vat (%)',
  'Merchant Commission (%)',
  'Commission ($)',

  'Delivery Fee Amount ($)',
  'Delivery Fee Rate (%)',
  'Delivery Fee Commission ($)',

  'Voucher',
  'Voucher Code',
  'Voucher Amount',

  'Merchant Promotion Discount',
  'Delivery Discount',
  'Small Order Fee',
  'Order Dynamic Fee (company)',
  'Order Dynamic Fee (merchant)',
  'Order Dynamic Fee (driver)',
  'Markup Percentage',
  'Merchant Discount Cost (%)',
  'Compnay Discount Cost (%)',
  'Name',
  'Tel',
  'Payment Type',
  'Payment Ref',

  'GrandTotal',

  'Complete / Reject',
  'Order Damage',
  'Rejected Code',

  'Accepted By',

  'Region',
  'Merchant Type',
  'Merchant Categories',
  'Merchant Tags',
]

class FoodAndBeverageReport extends React.PureComponent {
  state = {
    startFrom: Number(
      moment()
        .startOf('month')
        .format('x')
    ),
    endAt: Number(
      moment()
        .endOf('month')
        .format('x')
    ),
  }

  componentDidMount = () => {
    const { merchantCategoryLoaded, getMerchantCategories } = this.props

    if (!merchantCategoryLoaded) {
      getMerchantCategories()
    }
  }

  arrangeFinanceReportDataRow = (order, index, merchantCategoriesAndTags) => {
    const {
      firebase_key: firebaseKey,

      deliverer_key: delivererKey,
      delivery_fee: deliveryFee,
      delivery_commission_rate: deliveryCommissionRate,

      rejected_code: rejectedCode,

      customer_name: customerName,
      customer_tel: customerTel,
      promotion_discount: promotionDiscount,
      delivery_discount: deliveryDiscount,

      merchant_branch_pay_later: payLater,
      merchant_branch_pay_later_type: payLaterType = 'net',

      merchant_key: merchantKey,
      merchant_name: merchantName,
      merchant_type: merchantType,
      merchant_vat_rate: merchantVatRate,
      merchant_commission_rate: merchantCommissionRate,

      branch_name: branchName,

      voucher_type: voucherType,
      voucher_code: voucherCode,
      voucher_discount_amount: voucherDiscountAmount,

      created_at: createdAt,
      accepted_by: acceptedBy = 'n/a',
      status,
      region = 'pnh',
      subtotal,
      payments,
      dynamic_fees: dynamicFees,
      merchant_markup_percentage: merchantMarkupPercentage,
      promotion_cost_sharing: promotionCostSharing,
    } = order
    let displayMerchantType = 'Food'

    const delivererFeeRate = deliveryCommissionRate === null ? 0 : deliveryCommissionRate
    const payment = payments ? payments[0] : undefined

    const tags = merchantCategoriesAndTags[merchantKey] ? merchantCategoriesAndTags[merchantKey].tags : []
    const categories = merchantCategoriesAndTags[merchantKey]
      ? merchantCategoriesAndTags[merchantKey].categories
      : []
    const smallOrderFee = _.find(dynamicFees, val => val.name === 'Small Order Fee')

    const { fee_amount: smallOrderFeeAmount = 0 } = smallOrderFee || {}

    const customerGrandTotal = utils.calculateCustomerGrandTotal({
      subtotal,
      deliveryFee,
      merchantVatRate,
      dynamicFees,
      voucherDiscountAmount,
      promotionDiscount,
      deliveryDiscount,
    })

    const { driverFees, merchantFees, companyFees } = utils.serializeDynamicFees(dynamicFees)

    const { merchant_discount: merchantDiscountCost = 0, company_discount: companyDiscountCost = 0 } =
      promotionCostSharing || {}

    if(merchantType && merchantType === 'mart') displayMerchantType = 'Mart'
    return [
      index + 1,
      firebaseKey,
      `${moment(createdAt).format('DD-MMM-YYYY')}`,
      `${moment(createdAt).format('HH:mm:ss')}`,
      `${delivererKey || ''}`,
      `${merchantName}`,
      `${branchName}`,

      `${payLater ? 'Pay Later' : 'COD'}`,
      payLaterType,
      `$${Number(subtotal).toFixed(2)}`,
      `${merchantVatRate}%`,
      `${merchantCommissionRate}%`,
      `$${Number(subtotal * (merchantCommissionRate / 100)).toFixed(2)}`,

      `$${Number(deliveryFee).toFixed(2)}`,
      `${delivererFeeRate}%`,
      `$${Number(deliveryFee * (delivererFeeRate / 100)).toFixed(2)}`,

      voucherType,
      voucherCode,
      `$${Number(voucherDiscountAmount).toFixed(2)}`,

      `$${Number(promotionDiscount).toFixed(2)}`,
      `$${Number(deliveryDiscount).toFixed(2)}`,
      `$${Number(smallOrderFeeAmount).toFixed(2)}`,
      `$${Number(companyFees.totalAmount).toFixed(2)}`,
      `$${Number(merchantFees.totalAmount).toFixed(2)}`,
      `$${Number(driverFees.totalAmount).toFixed(2)}`,
      `${merchantMarkupPercentage || 0}%`,
      `$${Number(merchantDiscountCost).toFixed(2)}`,
      `$${Number(companyDiscountCost).toFixed(2)}`,
      `${customerName}`,
      `${customerTel}`,
      `${payment ? payment.provider : 'Cash'}`,
      `${payment ? payment.tran_id : 'None'}`,

      `$${Number(customerGrandTotal)}`,

      `${status === 'delivered' ? 'delivered' : 'rejected'}`,

      `${rejectedCode ? 'true' : 'false'}`,
      `${rejectedCode || ''}`,

      acceptedBy,
      region,
      displayMerchantType,
      `${categories.filter(Boolean).join(' - ')}`,
      `${tags.filter(Boolean).join(' - ')}`,
    ]
  }

  getOrderByDate = () => {
    const { startFrom, endAt } = this.state
    const { fetchOrders, setOrders } = this.props
    setOrders([])
    fetchOrders(startFrom, endAt)
  }

  onFieldChange = (field, value) => {
    this.setState({ [field]: value })
  }

  validateSearchByDate = () => {
    const { startFrom, endAt } = this.state
    const ONE_MONTH_IN_MILLISECOND = 2764800000

    const errors = []
    if (startFrom > endAt) {
      errors.push({ type: 'Date Invalid', value: 'Date invalid, please check it again' })
    }

    if (endAt - startFrom > ONE_MONTH_IN_MILLISECOND) {
      errors.push({
        type: 'Date Exceed a Month',
        value: 'Date range exceed the month, please check it again',
      })
    }

    return { errors }
  }

  onSearch = () => {
    const validation = this.validateSearchByDate()
    if (validation.errors.length < 1) {
      this.getOrderByDate()
    } else {


      alert(validation.errors.map(err => err.value).join(', '))
    }
  }

  renderContent = () => {
    const { startFrom, endAt } = this.state
    const { orders, loading, merchantCategories } = this.props
    const merchantCategoriesAndTags = merchantCategories

    const formattedRows = orders.map((ord, index) => {
      return this.arrangeFinanceReportDataRow(ord, index, merchantCategoriesAndTags)
    })

    return (
      <Segment style={{ height: '100%', overflow: 'auto' }}>
        {loading && (
          <Dimmer active inverted>
            <Loader />
          </Dimmer>
        )}
        <div style={{ padding: '0px 14px' }}>
          <DateField
            startFrom={startFrom}
            endAt={endAt}
            loading={loading}
            onSearch={this.onSearch}
            onFieldChange={this.onFieldChange}
          />
          <div
            style={{
              height: 500,
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <SaleReportSheet orders={formattedRows} startFrom={startFrom} endAt={endAt} headers={headers} />
          </div>

          {/* <Header as="h2">{loading ? 'Loading' : 'Complete'}</Header> */}
          {/* <OrderTable orders={formattedRows} headers={headers} /> */}
        </div>
      </Segment>
    )
  }

  render() {
    return this.renderContent()
  }
}

const mapState = ({ hasuraOrders, menus, tags }) => ({
  orders: hasuraOrders.saleReports,
  tags: tags.data,
  menus: menus.data,
  loading: hasuraOrders.loading,

  merchantCategories: hasuraOrders.merchantCategories,
  merchantCategoryLoaded: hasuraOrders.merchantCategoryLoaded,
})

const mapDispatch = {
  fetchOrders: HasuraOrderActions.getSaleReports,
  setOrders: HasuraOrderActions.setSaleReports,
  getMerchantCategories: HasuraOrderActions.getMerchantCategories,
}

export default connect(
  mapState,
  mapDispatch
)(FoodAndBeverageReport)



// WEBPACK FOOTER //
// ./src/containers/reports/sale/foodAndBeverage.js